


// Userdetails.js
import React, { useEffect, useState, useMemo, useRef } from "react";
import "./Usermanagement.css";
import { Link } from "react-router-dom";
import ProfessionalUser from "./ProfessionalUser";
import PostPaidUsers from "./PostPaidUsers";
import {
    getAllUsers,
    getUserProfileByIdAPI,
} from "../../../Servicefile/userservicefile.jsx";
import { Calendar, ChevronDown } from "lucide-react";

// ============================================
// PREMIUM ICONS
// ============================================
const Icons = {
    Users: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    Active: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Inactive: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
    Professional: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Personal: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    ),
    Today: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
            <circle cx="12" cy="15" r="1" />
            <circle cx="16" cy="15" r="1" />
            <circle cx="8" cy="15" r="1" />
        </svg>
    ),
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    )
};

// Inline loader hook
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

// Date filter options
const dateFilterOptions = ["All", "Today", "Yesterday", "This Week", "This Month", "Last Month", "This Year", "Custom Range"];

const Userdetails = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
    const [activeTab, setActiveTab] = useState("User");
    const [searchType, setSearchType] = useState("userId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDate, setSelectedDate] = useState("");

    // Date filter states - Default "Today"
    const [selectedDateFilter, setSelectedDateFilter] = useState("All");
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [customFromDate, setCustomFromDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const dateDropdownRef = useRef(null);

    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0,
        professional: 0,
        personal: 0,
        dateRangeUsers: 0,
        dateRangeLabel: "Today's Users"
    });

    // Close date dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
                setShowDateDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Helper function to get date range from selection
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter data based on status, category, and date
    const filteredData = useMemo(() => {
        let result = data.filter(user => {
            const statusMatch = !selectedStatusFilter ||
                user.active === (selectedStatusFilter === "true");
            const categoryMatch = !selectedCategoryFilter ||
                (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
            return statusMatch && categoryMatch;
        });

        // Apply date filter
        const range = getDateRangeFromSelection();
        if (range) {
            const startDate = new Date(range.fromDate);
            startDate.setHours(0, 0, 0, 0);
            const endDate = new Date(range.toDate);
            endDate.setHours(23, 59, 59, 999);

            result = result.filter(item => {
                const registerDate = item.registeredTime ? new Date(item.registeredTime) : null;
                if (!registerDate) return false;
                return registerDate >= startDate && registerDate <= endDate;
            });
        }

        return result;
    }, [data, selectedStatusFilter, selectedCategoryFilter, selectedDateFilter, customFromDate, customToDate]);

    // Calculate stats - Total, Active, Inactive should be based on ALL data (no date filter)
    const calculateStats = useMemo(() => {
        // These should be based on ALL data, not filtered by date
        const allFilteredData = data.filter(user => {
            const statusMatch = !selectedStatusFilter ||
                user.active === (selectedStatusFilter === "true");
            const categoryMatch = !selectedCategoryFilter ||
                (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
            return statusMatch && categoryMatch;
        });

        const total = allFilteredData.length;
        const active = allFilteredData.filter(user => user.active === true).length;
        const inactive = allFilteredData.filter(user => user.active === false).length;
        const professional = allFilteredData.filter(user => user.userType === 'PROFESSIONAL' || user.userType === 'Professional').length;
        const personal = allFilteredData.filter(user => user.userType === 'PERSONAL' || user.userType === 'Personal').length;

        // For the date range box, use the filtered data (which already has date filter applied)
        const dateRangeUsers = filteredData.length;

        // Generate label based on selected date filter
        let dateRangeLabel = "Today's Users";
        if (selectedDateFilter === "Today") {
            dateRangeLabel = "Today's Users";
        } else if (selectedDateFilter === "Yesterday") {
            dateRangeLabel = "Yesterday's Users";
        } else if (selectedDateFilter === "This Week") {
            dateRangeLabel = "This Week's Users";
        } else if (selectedDateFilter === "This Month") {
            dateRangeLabel = "This Month's Users";
        } else if (selectedDateFilter === "Last Month") {
            dateRangeLabel = "Last Month's Users";
        } else if (selectedDateFilter === "This Year") {
            dateRangeLabel = "This Year's Users";
        } else if (selectedDateFilter === "Custom Range") {
            dateRangeLabel = `${customFromDate} to ${customToDate}`;
        } else if (selectedDateFilter === "All") {
            dateRangeLabel = "All Users";
        }

        return {
            total,
            active,
            inactive,
            professional,
            personal,
            dateRangeUsers,
            dateRangeLabel
        };
    }, [data, selectedStatusFilter, selectedCategoryFilter, filteredData, selectedDateFilter, customFromDate, customToDate]);

    useEffect(() => {
        setStats(calculateStats);
    }, [calculateStats]);

    const searchFilteredData = useMemo(() => {
        let result = filteredData;

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();

            result = result.filter((user) => {
                const actualField = fieldMapping[searchType];
                const fieldValue = user[actualField];

                if (!fieldValue) return false;

                if (searchType === "mobileNumber") {
                    const cleanUserMobile = fieldValue.toString().replace(/\D/g, "");
                    const cleanQuery = query.replace(/\D/g, "");

                    return (
                        fieldValue.toString().toLowerCase().includes(query) ||
                        cleanUserMobile.includes(cleanQuery)
                    );
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        // Sort by User ID (Highest to Lowest)
        return result.sort((a, b) => {
            return Number(b.userId) - Number(a.userId);
        });

    }, [filteredData, searchType, searchQuery]);

    const fieldMapping = {
        userId: "userId",
        userName: "userName",
        email: "emailId",
        mobileNumber: "mobileNumber",
    };

    const tabContent = {
        "User": <UserTabContent
            data={data}
            selectedStatusFilter={selectedStatusFilter}
            setSelectedStatusFilter={setSelectedStatusFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            setSelectedCategoryFilter={setSelectedCategoryFilter}
            filteredData={filteredData}
            stats={stats}
            selectedDateFilter={selectedDateFilter}
            setSelectedDateFilter={setSelectedDateFilter}
            showDateDropdown={showDateDropdown}
            setShowDateDropdown={setShowDateDropdown}
            customFromDate={customFromDate}
            setCustomFromDate={setCustomFromDate}
            customToDate={customToDate}
            setCustomToDate={setCustomToDate}
            showCustomPicker={showCustomPicker}
            setShowCustomPicker={setShowCustomPicker}
            dateDropdownRef={dateDropdownRef}
            dateFilterOptions={dateFilterOptions}
            getDateFilterDisplayText={() => {
                if (selectedDateFilter === "All") return "All";
                if (selectedDateFilter === "Custom Range") {
                    return `${customFromDate} to ${customToDate}`;
                }
                return selectedDateFilter;
            }}
            handleDateFilterSelect={(filter) => {
                setSelectedDateFilter(filter);
                if (filter === "Custom Range") {
                    setShowCustomPicker(true);
                } else {
                    setShowCustomPicker(false);
                    setShowDateDropdown(false);
                }
            }}
            applyCustomRange={() => {
                setShowCustomPicker(false);
                setShowDateDropdown(false);
            }}
        />,
    };

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const authToken = localStorage.getItem("authToken");

        const fetchUsers = async () => {
            try {
                showLoader();

                const fetchedData = await getAllUsers(authToken);

                // Get all users without filtering
                const dataWithSno = fetchedData.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    orders: typeof item.orders === "number" ? item.orders : 0,
                    last: item.lastOrderDate || item.last || "N/A",
                    statusAsDeliveryAgent:
                        item.status || item.statusAsDeliveryAgent || "N/A",
                }));

                setData(dataWithSno);

            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            } finally {
                hideLoader();
            }
        };

        fetchUsers();

        return () => controller.abort();
    }, []);

    return (
        <div className="user-management-wrapper">
            {/* Global Loader */}
            {globalLoading && (
                <div className="global-loader-overlay" style={{
                    opacity: fadeOut ? 0 : 1,
                    pointerEvents: fadeOut ? 'none' : 'auto'
                }}>
                    <div className="loader-content">
                        <div className="loader-brand">
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    className="loader-letter"
                                    style={{ animationDelay: `${i * 0.1}s` }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>
                        <div className="loader-progress-bar">
                            <div className="loader-progress-fill"></div>
                        </div>
                        <div className="loader-text">Loading user data...</div>
                    </div>
                </div>
            )}

            <div className="user-management-layout">
                <div className="user-management-content">
                    {/* Tab Content */}
                    <div className="tab-content-container">
                        <UserTabContent
                            data={data}
                            selectedStatusFilter={selectedStatusFilter}
                            setSelectedStatusFilter={setSelectedStatusFilter}
                            selectedCategoryFilter={selectedCategoryFilter}
                            setSelectedCategoryFilter={setSelectedCategoryFilter}
                            filteredData={filteredData}
                            stats={stats}
                            selectedDateFilter={selectedDateFilter}
                            setSelectedDateFilter={setSelectedDateFilter}
                            showDateDropdown={showDateDropdown}
                            setShowDateDropdown={setShowDateDropdown}
                            customFromDate={customFromDate}
                            setCustomFromDate={setCustomFromDate}
                            customToDate={customToDate}
                            setCustomToDate={setCustomToDate}
                            showCustomPicker={showCustomPicker}
                            setShowCustomPicker={setShowCustomPicker}
                            dateDropdownRef={dateDropdownRef}
                            dateFilterOptions={dateFilterOptions}
                            getDateFilterDisplayText={() => {
                                if (selectedDateFilter === "All") return "All";
                                if (selectedDateFilter === "Custom Range") {
                                    return `${customFromDate} to ${customToDate}`;
                                }
                                return selectedDateFilter;
                            }}
                            handleDateFilterSelect={(filter) => {
                                setSelectedDateFilter(filter);
                                if (filter === "Custom Range") {
                                    setShowCustomPicker(true);
                                } else {
                                    setShowCustomPicker(false);
                                    setShowDateDropdown(false);
                                }
                            }}
                            applyCustomRange={() => {
                                setShowCustomPicker(false);
                                setShowDateDropdown(false);
                            }}
                        />
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
                .global-loader-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.95);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 999999;
                    transition: opacity 0.4s ease;
                }
                .loader-content {
                    text-align: center;
                }
                .loader-brand {
                    font-size: 2.5rem;
                    font-weight: 900;
                    letter-spacing: 6px;
                    margin-bottom: 30px;
                }
                .loader-letter {
                    display: inline-block;
                    opacity: 0;
                    transform: translateY(30px);
                    animation: letterAnim 0.8s ease forwards;
                    color: #e50914;
                }
                .loader-progress-bar {
                    width: 280px;
                    height: 4px;
                    background: rgba(255,255,255,0.2);
                    overflow: hidden;
                    margin: 0 auto;
                }
                .loader-progress-fill {
                    width: 40%;
                    height: 100%;
                    background: linear-gradient(90deg, #e50914, #ff6b6b);
                    animation: progress 1.8s infinite;
                }
                .loader-text {
                    margin-top: 20px;
                    color: #aaa;
                    font-size: 14px;
                }
                .user-management-wrapper {
                    padding: 10px;
                    margin-top:70px;
                }
                .user-management-layout {
                    margin: 0 auto;
                }
                .user-management-content {
                    overflow: hidden;
                    scrollbar-width:none;
                }
                .tab-content-container {
                    padding: 2px;
                }
                .tab-content-container::-webkit-scrollbar {
                    width: 6px;
                }
                .tab-content-container::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }
                .tab-content-container::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 10px;
                }
                .tab-content-container::-webkit-scrollbar-thumb:hover {
                    background: #a8a8a8;
                }
                @media (max-width: 768px) {
                    .user-management-wrapper {
                        padding: 10px;
                    }
                    .tab-content-container {
                        padding: 15px;
                    }
                }
                @media (max-width: 480px) {
                    .loader-brand {
                        font-size: 1.8rem;
                        letter-spacing: 4px;
                    }
                    .loader-progress-bar {
                        width: 200px;
                    }
                }
            `}</style>
        </div>
    );
};

// User Tab Component
const UserTabContent = ({
    data,
    selectedStatusFilter,
    setSelectedStatusFilter,
    selectedCategoryFilter,
    setSelectedCategoryFilter,
    filteredData,
    stats,
    selectedDateFilter,
    setSelectedDateFilter,
    showDateDropdown,
    setShowDateDropdown,
    customFromDate,
    setCustomFromDate,
    customToDate,
    setCustomToDate,
    showCustomPicker,
    setShowCustomPicker,
    dateDropdownRef,
    dateFilterOptions,
    getDateFilterDisplayText,
    handleDateFilterSelect,
    applyCustomRange
}) => {
    const [searchType, setSearchType] = useState("userId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loadingProfile, setLoadingProfile] = useState(false);
    const { showLoader: showProfileLoader, hideLoader: hideProfileLoader, loading: profileLoading, fadeOut: profileFadeOut } = useInlineLoader();

    const searchOptions = [
        { value: "userId", label: "User ID" },
        { value: "userName", label: "User Name" },
        { value: "email", label: "Email" },
        { value: "mobileNumber", label: "Mobile Number" }
    ];

    const fieldMapping = {
        userId: 'userId',
        userName: 'userName',
        email: 'emailId',
        mobileNumber: 'mobileNumber'
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return "-";
        const date = new Date(dateValue);
        return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
    };

    const formatTime = (dateValue) => {
        if (!dateValue) return "-";
        const date = new Date(dateValue);
        return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
    };

    // Get date range from selection
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter by date range (frontend)
    const filterByDateRange = (items) => {
        const range = getDateRangeFromSelection();
        if (!range) return items;

        const startDate = new Date(range.fromDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range.toDate);
        endDate.setHours(23, 59, 59, 999);

        return items.filter(item => {
            const registerDate = item.registeredTime ? new Date(item.registeredTime) : null;
            if (!registerDate) return false;
            return registerDate >= startDate && registerDate <= endDate;
        });
    };

    const searchFilteredData = useMemo(() => {
        let result = filteredData;

        // APPLY DATE FILTER FIRST
        result = filterByDateRange(result);

        // Apply search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter((user) => {
                const actualField = fieldMapping[searchType];
                const fieldValue = user[actualField];
                if (!fieldValue) return false;
                if (searchType === "mobileNumber") {
                    const cleanUserMobile = fieldValue.toString().replace(/\D/g, "");
                    const cleanQuery = query.replace(/\D/g, "");
                    return fieldValue.toString().toLowerCase().includes(query) || cleanUserMobile.includes(cleanQuery);
                }
                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        // Sort by User ID (Highest to Lowest)
        return result.sort((a, b) => {
            return Number(b.userId) - Number(a.userId);
        });

    }, [filteredData, searchType, searchQuery, selectedDateFilter, customFromDate, customToDate]);

    const handleExportFiltered = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : filteredData;
        if (exportData.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = ["S.NO", "Customer ID", "Name", "Email", "Phone Number", "Status"];
        const csvRows = exportData.map((user, index) => [
            index + 1,
            user.userId || 'N/A',
            user.userName || 'N/A',
            user.emailId || 'N/A',
            user.mobileNumber || 'N/A',
            user.active ? "Active" : "Inactive"
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "filtered_users.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setSelectedCategoryFilter("");
        setSelectedDateFilter("Today");
        setCustomFromDate(new Date().toISOString().split('T')[0]);
        setCustomToDate(new Date().toISOString().split('T')[0]);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "userId": return "Search by User ID...";
            case "userName": return "Search by Name...";
            case "email": return "Search by Email...";
            case "mobileNumber": return "Search by Mobile...";
            default: return "Search...";
        }
    };

    const fetchUserProfileById = async (userId) => {
        setLoadingProfile(true);
        showProfileLoader();
        try {
            const data = await getUserProfileByIdAPI(userId);
            setSelectedCustomer(data);
        } catch (error) {
            console.error("Error fetching user profile:", error);
            alert("Unable to fetch user details");
        } finally {
            setLoadingProfile(false);
            hideProfileLoader();
        }
    };

    return (
        <div className="user-tab-container">
            {/* Profile Loader */}
            {profileLoading && (
                <div className="profile-loader-overlay" style={{
                    opacity: profileFadeOut ? 0 : 1,
                    pointerEvents: profileFadeOut ? 'none' : 'auto'
                }}>
                    <div className="loader-content">
                        <div className="loader-brand">
                            {"MAAMAAS".split("").map((l, i) => (
                                <span key={i} className="loader-letter" style={{ animationDelay: `${i * 0.1}s` }}>
                                    {l}
                                </span>
                            ))}
                        </div>
                        <div className="loader-progress-bar">
                            <div className="loader-progress-fill"></div>
                        </div>
                        <div className="loader-text">Loading user profile...</div>
                    </div>
                </div>
            )}

            {/* Dashboard Stats Section */}
            <div className="dashboard-stats-grid">
                {/* Total Users */}
                <div className="stat-card-box">
                    <div className="stat-icon-wrapper" style={{ background: '#e8f0fe', color: '#1a73e8' }}>
                        <Icons.Users />
                    </div>
                    <div className="stat-info">
                        <div className="stat-number">{stats.total}</div>
                        <div className="stat-label">Total Users</div>
                    </div>
                </div>



                {/* Inactive Users */}
                {/* <div className="stat-card-box">
                    <div className="stat-icon-wrapper" style={{ background: '#f8d7da', color: '#721c24' }}>
                        <Icons.Inactive />
                    </div>
                    <div className="stat-info">
                        <div className="stat-number">{stats.inactive}</div>
                        <div className="stat-label">Inactive Users</div>
                    </div>
                </div> */}

                {/* Date Range Users (formerly Today's Users) */}
                <div className="stat-card-box" style={{ borderColor: '#e66d33', borderWidth: '2px' }}>
                    <div className="stat-icon-wrapper" style={{ background: '#fef3e8', color: '#e66d33' }}>
                        <Icons.Today />
                    </div>
                    <div className="stat-info">
                        <div className="stat-number" style={{ color: '#e66d33' }}>{stats.dateRangeUsers}</div>
                        <div className="stat-label">{stats.dateRangeLabel}</div>
                    </div>
                </div>

                {/* Active Users */}
                <div className="stat-card-box">
                    <div className="stat-icon-wrapper" style={{ background: '#d4edda', color: '#155724' }}>
                        <Icons.Active />
                    </div>
                    <div className="stat-info">
                        <div className="stat-number">{stats.active}</div>
                        <div className="stat-label">Active Users</div>
                    </div>
                </div>
            </div>

            {/* Filters Section */}
            <div className="filters-section">
                <div className="filters-row">
                    <div className="filter-group">
                        <div className="search-group">
                            <select
                                className="search-select"
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="text"
                                className="search-input"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>

                        {/* Date Filter Dropdown */}
                        <div ref={dateDropdownRef} style={{ position: "relative" }}>
                            <button
                                onClick={() => setShowDateDropdown(!showDateDropdown)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '8px 16px',
                                    height: '40px',
                                    background: 'white',
                                    border: `1px solid ${showDateDropdown ? '#e66d33' : '#e0e0e0'}`,
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    minWidth: '160px'
                                }}
                            >
                                <Calendar size={16} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                                <span style={{ color: showDateDropdown ? '#e66d33' : '#334155' }}>{getDateFilterDisplayText()}</span>
                                <ChevronDown size={16} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                            </button>

                            {showDateDropdown && !showCustomPicker && (
                                <div style={{
                                    position: "absolute",
                                    top: "45px",
                                    left: 0,
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "12px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    minWidth: "180px",
                                    overflow: "hidden"
                                }}>
                                    {dateFilterOptions.map(option => (
                                        <div
                                            key={option}
                                            onClick={() => handleDateFilterSelect(option)}
                                            style={{
                                                padding: "10px 16px",
                                                fontSize: "13px",
                                                cursor: "pointer",
                                                background: selectedDateFilter === option ? "#fef3e8" : "white",
                                                color: selectedDateFilter === option ? "#e66d33" : "#334155",
                                                borderBottom: "1px solid #f0f0f0"
                                            }}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {showCustomPicker && (
                                <div style={{
                                    position: "absolute",
                                    top: "45px",
                                    left: 0,
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "12px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    width: "280px",
                                    padding: "16px"
                                }}>
                                    <div style={{ marginBottom: "12px" }}>
                                        <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>From Date</label>
                                        <input
                                            type="date"
                                            value={customFromDate}
                                            onChange={(e) => setCustomFromDate(e.target.value)}
                                            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                            max={customToDate}
                                        />
                                    </div>
                                    <div style={{ marginBottom: "16px" }}>
                                        <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>To Date</label>
                                        <input
                                            type="date"
                                            value={customToDate}
                                            onChange={(e) => setCustomToDate(e.target.value)}
                                            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                            min={customFromDate}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                    <button
                                        onClick={applyCustomRange}
                                        style={{ width: "100%", padding: "10px", background: "#e66d33", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}
                                    >
                                        Apply Range
                                    </button>
                                </div>
                            )}
                        </div>

                        <select
                            className="status-select"
                            value={selectedStatusFilter}
                            onChange={(e) => setSelectedStatusFilter(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                    </div>

                    <div className="action-group">
                        <button className="btn-clear" onClick={clearAllFilters}>
                            <Icons.Clear /> Clear
                        </button>
                        <button className="btn-export" onClick={handleExportFiltered}>
                            <Icons.Export /> Export CSV
                        </button>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <div className="table-wrapper">
                <div className="table-header">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: '4%' }}>#</th>
                                <th style={{ width: '8%' }}>Date</th>
                                <th style={{ width: '8%' }}>Time</th>
                                <th style={{ width: '12%' }}>Name</th>
                                <th style={{ width: '10%' }}>User ID</th>
                                <th style={{ width: '18%' }}>Email</th>
                                <th style={{ width: '12%' }}>Phone</th>
                                <th style={{ width: '10%' }}>Type</th>
                                <th style={{ width: '8%' }}>Status</th>
                                <th style={{ width: '6%' }}>View</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className="table-body">
                    <table>
                        <tbody>
                            {searchFilteredData.length > 0 ? (
                                searchFilteredData.map((user, index) => (
                                    <tr key={user.userId || index}>
                                        <td style={{ width: '4%' }}>{index + 1}</td>
                                        <td style={{ width: '8%' }}>{formatDate(user.registeredTime)}</td>
                                        <td style={{ width: '8%' }}>{formatTime(user.registeredTime)}</td>
                                        <td style={{ width: '12%' }}>{user.userName || '-'}</td>
                                        <td style={{ width: '10%' }}>{user.userId || '-'}</td>
                                        <td style={{ width: '18%' }}>{user.emailId || '-'}</td>
                                        <td style={{ width: '12%' }}>{user.mobileNumber || '-'}</td>
                                        <td style={{ width: '10%' }}>
                                            <span className="user-type-badge">
                                                {user.userType || '-'}
                                            </span>
                                        </td>
                                        <td style={{ width: '8%' }}>
                                            <span className={`status-badge ${user.active ? 'active' : 'inactive'}`}>
                                                {user.active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td style={{ width: '6%' }}>
                                            <button
                                                className="btn-view"
                                                onClick={() => fetchUserProfileById(user.userId)}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="no-data-cell" style={{}}>
                                        {data.length === 0
                                            ? "Loading data or no users found."
                                            : (searchQuery.trim() || selectedStatusFilter || selectedCategoryFilter)
                                                ? "No users found with the specified filters."
                                                : "No users match the current filters."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* User Details Modal */}
            {selectedCustomer && (
                <div className="modal-overlayyz" onClick={() => setSelectedCustomer(null)}>
                    <div className="modal-contentyz" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header-custom">
                            <h4 className="modal-title">User Profile Details</h4>
                            <button className="modal-close-btn" onClick={() => setSelectedCustomer(null)}>
                                ×
                            </button>
                        </div>
                        <div className="modal-body-custom">
                            {loadingProfile ? (
                                <div className="modal-loading">Loading user details...</div>
                            ) : (
                                <div className="user-profile-details">
                                    <div className="profile-row">
                                        <div className="profile-label">Name</div>
                                        <div className="profile-value">{selectedCustomer.userName || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Email</div>
                                        <div className="profile-value">{selectedCustomer.emailId || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Mobile</div>
                                        <div className="profile-value">{selectedCustomer.mobileNumber || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">User ID</div>
                                        <div className="profile-value">{selectedCustomer.userId || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">User Type</div>
                                        <div className="profile-value">
                                            <span className="user-type-badge">{selectedCustomer.userType || "-"}</span>
                                        </div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Status</div>
                                        <div className="profile-value">
                                            <span className={`status-badge ${selectedCustomer.active ? 'active' : 'inactive'}`}>
                                                {selectedCustomer.active ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Referral Code</div>
                                        <div className="profile-value">{selectedCustomer.referralCode || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Total Referrals</div>
                                        <div className="profile-value">{selectedCustomer.totalReferals ?? 0}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Total Cashback</div>
                                        <div className="profile-value">₹{selectedCustomer.totalCashBack ?? 0}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Registered On</div>
                                        <div className="profile-value">
                                            {selectedCustomer.registeredTime
                                                ? formatDate(selectedCustomer.registeredTime) + ' at ' + formatTime(selectedCustomer.registeredTime)
                                                : "-"}
                                        </div>
                                    </div>
                                    {selectedCustomer.image && (
                                        <div className="profile-row">
                                            <div className="profile-label">Profile Image</div>
                                            <div className="profile-value">
                                                <img
                                                    src={selectedCustomer.image}
                                                    alt="Profile"
                                                    className="profile-image"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer-custom">
                            <button className="btn-close-modal" onClick={() => setSelectedCustomer(null)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .user-tab-container {
                    padding: 10px 0;
                }
                .filters-section {
                    margin-bottom: 10px;
                    background: white;
                    border-radius: 12px;
                    padding: 0px;
                    box-shadow: 0 0px 0px rgba(0,0,0,0.06);
                }
                .filters-row {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    align-items: center;
                    justify-content: space-between;
                }
                .filter-group {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                    align-items: center;
                    flex: 1;
                }
                .search-group {
                    display: flex;
                    gap: 0;
                    align-items: center;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    overflow: hidden;
                    flex: 1;
                    min-width: 250px;
                }
                .search-select {
                    border: none;
                    padding: 8px 12px;
                    background: #f8f9fa;
                    font-size: 0.9rem;
                    border-right: 1px solid #e0e0e0;
                    min-width: 120px;
                    cursor: pointer;
                    height: 40px;
                }
                .search-input {
                    border: none;
                    padding: 8px 12px;
                    font-size: 0.9rem;
                    flex: 1;
                    min-width: 150px;
                    height: 40px;
                    outline: none;
                }
                .status-select {
                    padding: 8px 12px;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    font-size: 0.9rem;
                    height: 40px;
                    min-width: 140px;
                    background: white;
                    cursor: pointer;
                }
                .action-group {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                }
                .btn-clear {
                    padding: 8px 18px;
                    border: none;
                    border-radius: 8px;
                    background: #6c757d;
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                .btn-clear:hover {
                    background: #5a6268;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(108,117,125,0.3);
                }
                .btn-export {
                    padding: 8px 20px;
                    border: none;
                    border-radius: 8px;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                .btn-export:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 15px rgba(230,109,51,0.4);
                }
                .table-wrapper {
                    border: 1px solid #e8e8e8;
                    border-radius: 12px;
                    overflow: auto;
                    min-height:40vh;
                    background: white;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                }
                .table-header {
                    overflow: hidden;
                    background: #f8f9fa;
                }
                .table-header table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .table-header th {
                    padding: 12px 8px;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    color: white;
                    font-weight: 600;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    text-align: center;
                    white-space: nowrap;
                }
                .table-body {
                    max-height: 50vh;
                    overflow-y: auto;
                    scrollbar-width:thin;
                }
                .table-body table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .table-body td {
                    padding: 10px 8px;
                    font-size: 0.85rem;
                    text-align: center;
                    border-bottom: 1px solid #f0f0f0;
                    vertical-align: middle;
                }
                .table-body tr:nth-child(even) {
                    background: #fafbfc;
                }
                .table-body tr:hover {
                    background: #f0f4ff;
                }
                .user-type-badge {
                    display: inline-block;
                    padding: 2px 10px;
                    border-radius: 12px;
                    background: #e8f0fe;
                    color: #1a73e8;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                .status-badge {
                    display: inline-block;
                    padding: 2px 12px;
                    border-radius: 12px;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                .status-badge.active {
                    background: #d4edda;
                    color: #155724;
                }
                .status-badge.inactive {
                    background: #f8d7da;
                    color: #721c24;
                }
                .btn-view {
                    padding: 4px 14px;
                    border: none;
                    border-radius: 6px;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    color: white;
                    cursor: pointer;
                    font-size: 0.8rem;
                    transition: all 0.3s ease;
                }
                .btn-view:hover {
                    transform: scale(1.05);
                    box-shadow: 0 2px 10px rgba(230,109,51,0.3);
                }
                .no-data-cell {
                    padding: 30px !important;
                    text-align: center !important;
                    color: #999;
                    font-style: italic;
                    height:50vh;
                }
                /* Modal Styles */
                .modal-overlayyz {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10000;
                    animation: fadeIn 0.3s ease;
                    padding: 20px;
                }
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slideUp {
                    from { transform: translateY(30px) scale(0.95); opacity: 0; }
                    to { transform: translateY(0) scale(1); opacity: 1; }
                }
                .modal-contentyz {
                    background: white;
                    border-radius: 16px;
                    max-width: 550px;
                    width: 100%;
                    max-height: 85vh;
                    overflow-y: auto;
                    scrollbar-width:none;
                    animation: slideUp 0.3s ease;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
                }
                .modal-header-custom {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px 24px;
                    border-bottom: 1px solid #f0f0f0;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    border-radius: 16px 16px 0 0;
                }
                .modal-title {
                    margin: 0;
                    color: white;
                    font-weight: 600;
                    font-size: 1.2rem;
                }
                .modal-close-btn {
                    background: none;
                    border: none;
                    color: white;
                    font-size: 28px;
                    cursor: pointer;
                    padding: 0 8px;
                    opacity: 0.8;
                    transition: all 0.3s ease;
                }
                .modal-close-btn:hover {
                    opacity: 1;
                    transform: rotate(90deg);
                }
                .modal-body-custom {
                    padding: 24px;
                }
                .user-profile-details {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                .profile-row {
                    display: flex;
                    padding: 8px 0;
                    border-bottom: 1px solid #f5f5f5;
                }
                .profile-row:last-child {
                    border-bottom: none;
                }
                .profile-label {
                    font-weight: 600;
                    color: #555;
                    min-width: 140px;
                    font-size: 0.9rem;
                }
                .profile-value {
                    flex: 1;
                    color: #333;
                    font-size: 0.9rem;
                    word-break: break-word;
                }
                .profile-image {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 3px solid #e66d33;
                }
                .modal-footer-custom {
                    padding: 16px 24px;
                    border-top: 1px solid #f0f0f0;
                    text-align: right;
                }
                .btn-close-modal {
                    padding: 8px 24px;
                    border: none;
                    border-radius: 8px;
                    background: #6c757d;
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                .btn-close-modal:hover {
                    background: #5a6268;
                    transform: scale(1.02);
                }
                .modal-loading {
                    text-align: center;
                    padding: 20px;
                    color: #999;
                }
                .profile-loader-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.95);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 999998;
                    transition: opacity 0.4s ease;
                }
                /* Dashboard Stats */
                .dashboard-stats-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 16px;
                    margin-bottom: 20px;
                }
                .stat-card-box {
                    background: white;
                    border-radius: 12px;
                    padding: 16px 20px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                    border: 1px solid #f0f0f0;
                    transition: all 0.3s ease;
                }
                .stat-card-box:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
                }
                .stat-icon-wrapper {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }
                .stat-icon-wrapper svg {
                    width: 24px;
                    height: 24px;
                }
                .stat-info {
                    flex: 1;
                }
                .stat-number {
                    font-size: 24px;
                    font-weight: 700;
                    color: #333;
                    line-height: 1.2;
                }
                .stat-label {
                    font-size: 13px;
                    color: #888;
                    font-weight: 500;
                    margin-top: 2px;
                }
                /* Responsive */
                @media (max-width: 1200px) {
                    .dashboard-stats-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                         .filter-group {
        flex-direction: row;
    }
            .filters-row {
        flex-direction: row;
    }
                }
            
                @media (max-width: 768px) {
                    .filters-row {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .filter-group {
                        flex-direction: row;
                        align-items: stretch;
                    }
                    .search-group {
                        flex-direction: row;
                        border: 1px solid #e0e0e0;
                        border-radius: 8px;
                        min-width: unset;
                    }
                    .search-select {
                        border-right: none;
                        border-bottom: 1px solid #e0e0e0;
                        border-radius: 8px 8px 0 0;
                        width: 100%;
                    }
                    .search-input {
                        border-radius: 0 0 8px 8px;
                        width: 100%;
                    }
                    .status-select {
                        width: 100%;
                    }
                    .action-group {
                        flex-direction: row;
                        width: 100%;
                    }
                    .btn-clear,
                    .btn-export {
                        width: 100%;
                        justify-content: center;
                    }
                    .table-header th {
                        font-size: 0.7rem;
                        padding: 8px 4px;
                    }
                    .table-body td {
                        font-size: 0.75rem;
                        padding: 8px 4px;
                    }
                    .dashboard-stats-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                    .modal-content {
                        max-width: 95%;
                        margin: 10px;
                    }
                    .profile-row {
                        flex-direction: column;
                        gap: 4px;
                    }
                    .profile-label {
                        min-width: unset;
                        font-size: 0.8rem;
                    }
                    .profile-value {
                        font-size: 0.85rem;
                    }
                }
                @media (max-width: 480px) {
                    .dashboard-stats-grid {
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                    }
                    .stat-card-box {
                        padding: 12px 14px;
                        gap: 10px;
                    }
                    .stat-icon-wrapper {
                        width: 36px;
                        height: 36px;
                    }
                    .stat-icon-wrapper svg {
                        width: 18px;
                        height: 18px;
                    }
                    .stat-number {
                        font-size: 18px;
                    }
                    .stat-label {
                        font-size: 11px;
                    }
                    .table-header th {
                        font-size: 0.6rem;
                        padding: 6px 2px;
                    }
                    .table-body td {
                        font-size: 0.65rem;
                        padding: 6px 2px;
                    }
                    .btn-view {
                        padding: 3px 8px;
                        font-size: 0.65rem;
                    }
                    .status-badge,
                    .user-type-badge {
                        font-size: 0.6rem;
                        padding: 1px 8px;
                    }
                    .modal-header-custom {
                        padding: 16px;
                    }
                    .modal-title {
                        font-size: 1rem;
                    }
                    .modal-body-custom {
                        padding: 16px;
                    }
                    .profile-image {
                        width: 60px;
                        height: 60px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Userdetails;